module.exports = __webpack_public_path__ + "static/media/duo-keys.1de23e34.svg";